import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { format } from 'date-fns';

import { DatePickerProps } from './types';

export default function DatePickerFilter({
  label,
  value,
  id,
  options,
  onValueChange
}: DatePickerProps) {
  const maxDate =
    options['maxDate'] !== undefined &&
    isNaN(Date.parse(options['maxDate'])) !== true
      ? new Date(options['maxDate'])
      : options.noMaxDateLimit
      ? undefined
      : new Date();
  const minDate =
    options['minDate'] !== undefined &&
    isNaN(Date.parse(options['minDate'])) !== true
      ? new Date(options['minDate'])
      : undefined;

  const handleChange = (selectedDate: any) => {
    if (selectedDate === null) {
      onValueChange({
        [id]: undefined
      });
    } else {
      if (selectedDate.$d.toString() === 'Invalid Date') return;
      onValueChange({
        [id]: format(selectedDate.$d, 'yyyy-MM-dd')
      });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        disabled={options.disabled}
        label={label}
        value={value || null}
        inputFormat={options.inputFormat || 'YYYY-MM-DD'}
        mask={options.mask || '____-__-__'}
        maxDate={maxDate}
        minDate={minDate}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            sx={{
              '& .MuiInputBase-root': {
                height: '49px'
              }
            }}
            {...params}
            inputProps={
              options.testId
                ? {
                    ...params.inputProps,
                    'data-testid': options.testId
                  }
                : params.inputProps
            }
            error={options.error}
          />
        )}
      />
    </LocalizationProvider>
  );
}
